import axios, {AxiosError, AxiosResponse} from "axios";
import {AdsApiResponse, Asset} from "../../interface/Server";
//  ADS-002
// "Asset Detail
// Get asset by assetId
//
// Endpoint:
//     /ads/asset/{assetId}
//
// Method:
//     GET
//
// Return:
// {
//     'code': 10000,
//     'msg': “OK”,
//     'data': {
//     'assetId': 1,
//         'englishName': 'Big-leaved Fig',
//         'chineseName': '大葉榕',
//         'technicalName': 'Ficus virens',
//         'venue': 'Art Park 藝術公園',
//         'location': '1 (Zone A)',
//         'inventoryId': 'AP/1/FV2/001',
//         'online': false,
//         'startDate': '01/01/2019',
//         'endDate': null,
//         'description': null,
//         'source':
//     'https://wkcda.sharepoint.com/sites/External/det/GGA/DEV/Adopt%20a%20Tree_Materials_20181212_v1.pptx',
//         'purchased': false,
//         'fundraisingUpdates': null,
//         'tcRead': null,
//         'picsRead': null,
//         'giftAcknowledgementEmailSent': null,
//         'accountID': null,
//         'primaryEmail': null,
//         'westKowloonENewsletter': null,
//         'giftId': null,
//         'tributeType': null,
//         'tributeName': null,
//         'acknowledgementNameENG': null,
//         'acknowledgementNameCHI': null,
//         'donorNameInReceipt': null,
//         'project': 'Adopt a Tree',
//         'giftAmount': 80000,
//         'giftAmountCurrency': 'HKD',
//         'tributeDescription': 'AP/1/FV2/001',
//         'image': null
// }
// }"


export const getAssetByAssetId = (assetId: number) => axios.get(`/asset/${assetId}`,).then((res: AxiosResponse) => res.data as AdsApiResponse<Asset>).catch((err: AxiosError) => console.log(err.message));
